import { useQuery } from '@tanstack/react-query'

import { getPackageCategoriesSelectQueryOptions } from '../query-options'

/**
 * Select用の荷姿一覧のUseQuery
 */
export const usePackageCategoriesSelectQuery = (
  tenantKey: string,
  options?: {
    disabled?: boolean
    dcId?: number
  }
) => {
  const disabled = options?.disabled ?? false
  const dcId = options?.dcId
  return useQuery({
    ...getPackageCategoriesSelectQueryOptions(tenantKey, dcId),
    enabled: !disabled,
    retry: false
  })
}
